import importer from 'common/importer';
const Config = importer('Config');
const { deloitReq: req } = importer('APIs', null);

let CORE_SCHEDULER_BASIC_AUTH;
if (Config.PLATFORM_TYPE != 'mobile') {
	CORE_SCHEDULER_BASIC_AUTH = WEB_SCHEDULER_BASIC_AUTH;
}

/**
 *
 * @param {String} userID `REQUIRED`
 * @param {String} oldPassword `REQUIRED`
 * @param {String} newPassword `REQUIRED`
 * @param {Object} headers
 */
const main = (userID, oldPassword, newPassword, authToken) => {
	const data = {
		userId: userID,
		oldPassword: oldPassword,
		newPassword: newPassword
	};
	const config = {
		headers: {
			Authorization: authToken
		}
	};
	return req.post(`/auth/change-password`, data, config);
};

export default main;
